module.exports = __webpack_public_path__ + "static/media/growth.9f55c82f.png";